<template>
  <section class="scheme">
    <div class="header">
      <div class="title">微信支付</div>
    </div>
    <div class="main">
      <div class="top"></div>
      <div id="pay">
        <div class="title">
          支付金额
          <label>￥</label>
          <span id="price">{{order.amount}}</span>，请使用微信扫描下方二维码完成支付,请在 <span class="second">{{second}}</span>
          秒内完成支付.
        </div>
        <div class="middle">
          <div class="content">
            <div id="container" class="code">
              <div class="image" :style="'background:url('+scheme.qrcodes+') no-repeat;background-size:218px'"></div>
            </div>
            <ul>
              <li>
                <label>商家名称：</label>
                <span id="business">速回收</span>
              </li>
              <li>
                <label>商品名称：</label>
                <span id="commodity">{{order.goodsname}}</span>
              </li>
              <li>
                <label>交易单号：</label>
                <span id="transactionId">{{order.ordersn}}</span>
              </li>
              <li>
                <label>创建时间：</label>
                <span id="createTime">2019-06-03 20:36:04</span>
              </li>
            </ul>
          </div>
        </div>
      </div>
      <div id="error" class="error">
        <div class="content">
          <p class="tip">温馨提示</p>
          <p>
            <span id="errorText"></span>
          </p>
        </div>
      </div>
      <div class="bottom"></div>
      <div class="footer">
        <p>深圳协腾网络电子科技有限公司</p>
        <p>客服电话：0755-33528888</p>
      </div>
    </div>
  </section>
</template>

<script>
export default {
  data(){
    return {
      second:180
    }
  },
  computed: {
    order() {
      return this.$store.state.order.neworder;
    },
    scheme() {
      return this.$store.state.wechat.wechatscheme;
    }
  },
  inject: ["reload"],
  methods: {
    fetchOrderPay() {
      let params = {
        ordersn: this.order.ordersn
      };
      this.$store.dispatch("order/fetchOrderPay", { params }).then(() => {
        console.log(this.$store.state.order)
        if(this.$store.state.order.orderpay.errno==0){
          this.$router.push({ path: "/done" })
        }
        // this.reload();
      });
    },
    countTime(){
      this.second --;
      if(this.second<1){
        window.location.href="https://www.suhuishou.com/pc/#/user";
      }
      setTimeout(this.countTime, 1000);
      
    }
  },
  mounted() {
    let _this = this;
    _this.countTime();
    setTimeout(function() {
      _this.fetchOrderPay();
    }, 10000);
  }
};
</script>

<style scoped>
.scheme {
  background: #e3e8f6;
  height: 100%;
}
.header {
  margin: 0;
  background: #fff;
  height: 80px;
  line-height: 80px;
  border: 1px solid #dbe0ec;
  color: #333;
  font-size: 16px;
}

.header .title {
  margin: 0 auto;
  width: 130px;
  background: url(https://console.bce.baidu.com/finance/asset/img/weixin.png)
    left center no-repeat;
  padding: 0 0 0 62px;
}

.main {
  width: 960px;
  margin: 30px auto 35px auto;
}

.main .top {
  height: 9px;
  background: url(https://console.bce.baidu.com/finance/asset/img/top.png) 0 0
    no-repeat;
}

.main .title {
  height: 80px;
  line-height: 80px;
  padding: 0 97px 0 153px;
  font-size: 18px;
  background: #fff;
  border-color: #dde2ed;
  border-style: solid;
  border-width: 0 1px;
}

.main .title label,
.main .title span {
  color: #e0151b;
}

.main .title label {
  font-size: 12px;
}

.main .middle {
  border-color: #dde2ed;
  border-style: solid;
  border-width: 0 1px;
  background: #fff;
  padding: 0 97px;
}

.main .middle .content {
  border-top: 1px dashed #f0f0f0;
  padding: 35px 35px 20px 35px;
}

.main .middle .content:after {
  content: "";
  clear: both;
  display: block;
}

.code {
  float: left;
  width: 218px;
  height: 218px;
}
.code .image {
  width: 218px;
  height: 218px;
  background-size: 100%;
}
.middle ul {
  margin: 16px 0 0 263px;
}

.middle ul label {
  color: #999;
}

.middle li {
  list-style: none;
  line-height: 38px;
}

.bottom {
  background: url(https://console.bce.baidu.com/finance/asset/img/bottom.png)
    no-repeat;
  height: 43px;
}

.footer {
  padding: 0;
  height: 75px;
  border-color: #dde2ed;
  border-style: solid;
  border-width: 0 1px 1px 1px;
  background-color: #fff;
  color: #ccc;
  text-align: center;
}

.footer p {
  margin: 0;
  padding: 0;
  line-height: 30px;
  font-size: 14px;
}

.error {
  height: 200px;
  background: #fff;
  padding-top: 154px;
  display: none;
}

.error .content {
  width: 200px;
  min-height: 110px;
  margin: 0 auto;
  padding-left: 117px;
  background: url(https://console.bce.baidu.com/finance/asset/img/error.png)
    left center no-repeat;
}

.error .content p {
  margin: 0;
}

.error .content .tip {
  padding-top: 20px;
  margin-bottom: 10px;
}

.error .content span {
  font-size: 14px;
  color: #999;
}
</style>
